import React from "react";

import Design from "./designs/Design";
import { DesignContainer, PanelAdvancedTemplatesContainer } from "./styles";
import { usePanelAdvancedStore } from "../../../../../../stores/use-panel-advanced-store";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import { getPanelAdvancedTemplates } from "./panel-advanced-templates";

const PanelAdvancedTemplates = () => {
  const { data, setData } = usePanelAdvancedStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const hasData = !!Object.keys(data).length;
  const templates = getPanelAdvancedTemplates(styleguideSetup);

  return (
    <PanelAdvancedTemplatesContainer>
      {templates.map((template) => (
        <DesignContainer
          onClick={() => {
            if (hasData) {
              setData({
                ...data,
                style: template.style,
              });
            } else {
              setData(template);
            }
            setDrawers({ templates: false, settings: true });
          }}
        >
          <Design data={template} isPreview />
        </DesignContainer>
      ))}
    </PanelAdvancedTemplatesContainer>
  );
};

export default PanelAdvancedTemplates;
